import Constant from '@/common/constant/Constant';


/**
 * Get chatPost by id
 * @param {*} organizationDomain 
 * @returns expressionStr
 */
export const getExpressionQueryChatPostByChatThreadId = (chatThreadId,limit,sortDirection) => {
    const scanIndexForward = sortDirection === 'desc' ? false : true
    let expression = {
        IndexName: Constant.GSI.CHAT_THREAD_ID_AND_CREATED_AT_INDEX,
        KeyConditionExpression: '#chatThreadId = :chatThreadId',
        ExpressionAttributeNames: {
            '#chatThreadId': 'chatThreadId'
        },
        ExpressionAttributeValues: {
            ':chatThreadId': {
                S: chatThreadId
            }
        },
        Limit: limit,
        ScanIndexForward : scanIndexForward
    };
    return expression;
};


/**
 * Get chatPost unread by id
 * @param {*} organizationDomain 
 * @returns expressionStr
 */
export const getExpressionQueryChatPostUnReadByChatThreadId = (
    chatThreadId,
    userId,
    limit,
    sortDirection
) => {
    const scanIndexForward = sortDirection === 'desc' ? false : true;
    let expression = {
        IndexName: Constant.GSI.CHAT_THREAD_ID_AND_CREATED_AT_INDEX,
        KeyConditionExpression: '#chatThreadId = :chatThreadId',
        ExpressionAttributeNames: {
            '#chatThreadId': 'chatThreadId',
            '#creatorId': 'creatorId',
            '#footPrint': 'footPrint',
            '#userList': 'userList',
            '#status': 'status',
        },
        ExpressionAttributeValues: {
            ':chatThreadId': {
                S: chatThreadId
            },
            ':creatorId': {
                S: `${userId}`
            },
            ':status': {
                N: `${Constant.CHAT_POST_STATUS.DELETE_READ}`
            }
        },
        FilterExpression: '#creatorId <> :creatorId AND #status <> :status AND not contains(#footPrint.#userList, :creatorId)',
        Limit: limit,
        ScanIndexForward: scanIndexForward
    };
    return expression;
};